"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PurePayment = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _api = require("../../api");
var _Button = _interopRequireDefault(require("../Button"));
var _Adyen = _interopRequireDefault(require("../Adyen"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _SectionHeader = _interopRequireDefault(require("../SectionHeader"));
var _finalizePaymentSlice = require("../../redux/finalizePaymentSlice");
var _auth = _interopRequireDefault(require("../../services/auth"));
var _reactRedux = require("react-redux");
var _paymentMethodHelper = require("../../util/paymentMethodHelper");
var _publisherConfigSlice = require("../../redux/publisherConfigSlice");
var _orderSlice = require("../../redux/orderSlice");
var _paymentMethodsSlice = require("../../redux/paymentMethodsSlice");
var _paymentSlice = require("../../redux/paymentSlice");
var _PaymentStyled = require("./PaymentStyled");
var _eventDispatcher = _interopRequireWildcard(require("../../util/eventDispatcher"));
var _LegalNote = _interopRequireDefault(require("./LegalNote/LegalNote"));
var _PayPal = _interopRequireDefault(require("./PayPal/PayPal"));
var _DropInSection = _interopRequireDefault(require("./DropInSection/DropInSection"));
var _util = require("../../util");
var _LegalCopy = _interopRequireDefault(require("./LegalCopy/LegalCopy"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Payment = function Payment(_ref) {
  var _order$offerId;
  var onPaymentComplete = _ref.onPaymentComplete;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.publisherConfig;
    }),
    publisherPaymentMethods = _useSelector.paymentMethods,
    isPayPalHidden = _useSelector.isPayPalHidden,
    visiblePaymentMethods = _useSelector.visiblePaymentMethods;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var order = (0, _reactRedux.useSelector)(function (state) {
    return state.order.order;
  });
  var isPaymentDetailsRequired = order.requiredPaymentDetails;
  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
      return state.offer.offer;
    }),
    offerPeriod = _useSelector2.period;
  var _useSelector3 = (0, _reactRedux.useSelector)(function (state) {
      return state.finalizeInitialPayment;
    }),
    isPaymentFinalizationInProgress = _useSelector3.loading;
  var period = offerPeriod ? _util.periodMapper[offerPeriod].chargedForEveryText : null;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    generalError = _useState4[0],
    setGeneralError = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    standardDropInInstance = _useState6[0],
    setStandardDropInInstance = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    bankDropInInstance = _useState8[0],
    setBankDropInInstance = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    adyenKey = _useState10[0],
    setAdyenKey = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    isActionHandlingProcessing = _useState12[0],
    setIsActionHandlingProcessing = _useState12[1];
  var dispatch = (0, _reactRedux.useDispatch)();

  // order updates
  var updateOrderWithPaymentMethodId = function updateOrderWithPaymentMethodId(methodId) {
    setGeneralError('');
    var id = order.id;
    if (id && methodId) {
      // TODO: (nice to have) validate if order.paymentId !== methodId. Pay attention to redux store and async
      dispatch((0, _orderSlice.fetchUpdateOrder)({
        id: id,
        payload: {
          paymentMethodId: methodId
        }
      })).unwrap().catch(function (errors) {
        if (errors.includes('JWT')) {
          _auth.default.logout(); // TODO: support properly the logout function
        }
      });
    }
  };

  // payment methods
  var selectPaymentMethodHandler = function selectPaymentMethodHandler(paymentMethodName) {
    var paymentMethodObj = publisherPaymentMethods.find(function (_ref2) {
      var methodName = _ref2.methodName;
      return methodName === paymentMethodName;
    });
    dispatch((0, _paymentMethodsSlice.setSelectedPaymentMethod)(paymentMethodObj));
    updateOrderWithPaymentMethodId(paymentMethodObj.id);
  };
  var fetchPaymentMethods = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var response, paymentMethodsFromBackend, validMethodsFromResponse;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            _context.next = 3;
            return (0, _api.getPaymentMethods)();
          case 3:
            response = _context.sent;
            paymentMethodsFromBackend = response.responseData.paymentMethods;
            validMethodsFromResponse = (0, _paymentMethodHelper.validatePaymentMethods)(paymentMethodsFromBackend, false);
            if (!response.errors.length) {
              _context.next = 9;
              break;
            }
            setGeneralError(t('Cannot fetch payment methods'));
            return _context.abrupt("return");
          case 9:
            dispatch((0, _publisherConfigSlice.updatePaymentMethods)(validMethodsFromResponse));
            setIsLoading(false);
            if (!(validMethodsFromResponse !== null && validMethodsFromResponse !== void 0 && validMethodsFromResponse.length)) {
              setGeneralError(t('Payment methods are not defined'));
            }
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchPaymentMethods() {
      return _ref3.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    if (publisherPaymentMethods.length === 1) {
      var _publisherPaymentMeth = (0, _slicedToArray2.default)(publisherPaymentMethods, 1),
        paymentMethod = _publisherPaymentMeth[0];
      selectPaymentMethodHandler(paymentMethod.methodName);
    }
  }, [publisherPaymentMethods]);
  var handlePayPalError = function handlePayPalError() {
    var search = window.location.search;
    if (search !== null && search !== void 0 && search.includes('message')) {
      setGeneralError(t('Your payment was not processed. Please, try again'));
    }
  };
  (0, _react.useEffect)(function () {
    fetchPaymentMethods();
    handlePayPalError();
  }, []);

  // PayPal
  var submitPayPal = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      var _yield$submitPayPalPa, responseData;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsLoading(true);
            _context2.next = 3;
            return (0, _api.submitPayPalPayment)();
          case 3:
            _yield$submitPayPalPa = _context2.sent;
            responseData = _yield$submitPayPalPa.responseData;
            if (responseData !== null && responseData !== void 0 && responseData.redirectUrl) {
              window.location.href = responseData.redirectUrl;
            } else {
              setIsLoading(false);
              setGeneralError(t('The payment failed. Please try again.'));
            }
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function submitPayPal() {
      return _ref4.apply(this, arguments);
    };
  }();

  // Adyen
  var onAdditionalDetails = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(state) {
      var details;
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            details = state.data.details;
            dispatch((0, _finalizePaymentSlice.fetchFinalizeInitialPayment)({
              orderId: order.id,
              details: details
            }));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function onAdditionalDetails(_x) {
      return _ref5.apply(this, arguments);
    };
  }();
  var onAdyenSubmit = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(state, component) {
      var _state$data, paymentMethod, browserInfo, billingAddress, _yield$submitPayment, errors, responseData, notSupportedMethod, action, payment;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _state$data = state.data, paymentMethod = _state$data.paymentMethod, browserInfo = _state$data.browserInfo, billingAddress = _state$data.billingAddress;
            setGeneralError('');
            setIsLoading(true);
            _context4.next = 5;
            return (0, _api.submitPayment)(paymentMethod, browserInfo, billingAddress);
          case 5:
            _yield$submitPayment = _context4.sent;
            errors = _yield$submitPayment.errors;
            responseData = _yield$submitPayment.responseData;
            if (!errors.length) {
              _context4.next = 17;
              break;
            }
            (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PURCHASE_FAILED, {
              reason: errors[0]
            });
            notSupportedMethod = errors[0].includes('Payment details are not supported');
            setGeneralError(notSupportedMethod ? t('Payment method not supported. Try different payment method') : t('The payment has not been processed. Please, try again with a different payment method.'));
            setIsLoading(false);
            // force Adyen remount
            setStandardDropInInstance(null);
            setBankDropInInstance(null);
            setAdyenKey(function (key) {
              return !key;
            });
            return _context4.abrupt("return");
          case 17:
            action = responseData.action, payment = responseData.payment;
            if (!action) {
              _context4.next = 22;
              break;
            }
            if (action.type !== 'redirect') {
              setIsActionHandlingProcessing(true);
            }
            component.handleAction(action);
            return _context4.abrupt("return");
          case 22:
            (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PURCHASE_SUCCESSFUL, {
              payment: payment
            });
            onPaymentComplete();
          case 24:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function onAdyenSubmit(_x2, _x3) {
      return _ref6.apply(this, arguments);
    };
  }();
  var getDropIn = function getDropIn(drop, type) {
    if (type === 'zeroPaymentNotSupported') {
      setBankDropInInstance(drop);
    } else {
      setStandardDropInInstance(drop);
    }
  };

  // Payment without payment details
  var paymentWithoutDetails = /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            setIsLoading(true);
            setGeneralError('');
            dispatch((0, _paymentSlice.submitPaymentWithoutDetails)()).unwrap().then(function (payment) {
              (0, _eventDispatcher.default)(_eventDispatcher.MSSDK_PURCHASE_SUCCESSFUL, {
                payment: payment
              });
              onPaymentComplete();
            }).catch(function () {
              setIsLoading(false);
              setGeneralError(t('The payment failed. Please try again.'));
            });
          case 3:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function paymentWithoutDetails() {
      return _ref7.apply(this, arguments);
    };
  }();
  var shouldShowPayPal = isPayPalHidden ? false : (0, _paymentMethodHelper.shouldShowGatewayComponent)('paypal', publisherPaymentMethods);
  var availablePaymentMethods = (0, _paymentMethodHelper.getAvailablePaymentMethods)(publisherPaymentMethods, visiblePaymentMethods);
  var shouldShowAdyen = (0, _paymentMethodHelper.shouldShowGatewayComponent)('adyen', availablePaymentMethods);
  var noPaymentMethods = !publisherPaymentMethods.length || !availablePaymentMethods.length && !shouldShowPayPal;
  var showPayPalWhenAdyenIsReady = function showPayPalWhenAdyenIsReady() {
    return shouldShowAdyen ? !!standardDropInInstance || !!bankDropInInstance : true;
  };
  if (noPaymentMethods && !isLoading) {
    return /*#__PURE__*/_react.default.createElement(_PaymentStyled.PaymentStyled, null, /*#__PURE__*/_react.default.createElement(_SectionHeader.default, {
      marginTop: "25px",
      center: true
    }, t('Purchase using')), generalError ? /*#__PURE__*/_react.default.createElement(_PaymentStyled.PaymentErrorStyled, null, generalError) : /*#__PURE__*/_react.default.createElement(_PaymentStyled.PaymentErrorStyled, null, t('Payment methods not available')));
  }
  if (!isPaymentDetailsRequired) {
    return /*#__PURE__*/_react.default.createElement(_PaymentStyled.PaymentStyled, null, generalError && /*#__PURE__*/_react.default.createElement(_PaymentStyled.PaymentErrorStyled, null, generalError), /*#__PURE__*/_react.default.createElement(_Button.default, {
      onClickFn: paymentWithoutDetails,
      theme: "confirm",
      width: "250px",
      size: "big",
      margin: "20px auto 0 auto"
    }, isLoading ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      buttonLoader: true,
      color: "#ffffff"
    }) : t('Complete purchase')));
  }
  return /*#__PURE__*/_react.default.createElement(_PaymentStyled.PaymentStyled, null, /*#__PURE__*/_react.default.createElement(_SectionHeader.default, {
    marginTop: "25px",
    paddingBottom: "0",
    center: true
  }, t('Purchase using')), /*#__PURE__*/_react.default.createElement(_LegalCopy.default, null), /*#__PURE__*/_react.default.createElement(_PaymentStyled.PaymentWrapperStyled, null, isPaymentFinalizationInProgress && /*#__PURE__*/_react.default.createElement(_Loader.default, null), shouldShowAdyen && /*#__PURE__*/_react.default.createElement(_Adyen.default, {
    key: adyenKey,
    onSubmit: onAdyenSubmit,
    selectPaymentMethod: selectPaymentMethodHandler,
    isPayPalAvailable: shouldShowPayPal,
    getDropIn: getDropIn,
    onAdditionalDetails: onAdditionalDetails
  }), shouldShowPayPal && showPayPalWhenAdyenIsReady() && !isActionHandlingProcessing && /*#__PURE__*/_react.default.createElement(_DropInSection.default, {
    selectPaymentMethod: selectPaymentMethodHandler,
    title: "PayPal",
    logo: "paypal",
    isLoading: isLoading
  }, /*#__PURE__*/_react.default.createElement(_PayPal.default, {
    totalPrice: order.totalPrice,
    offerId: order.offerId,
    onSubmit: submitPayPal,
    isLoading: isLoading
  })), generalError && /*#__PURE__*/_react.default.createElement(_PaymentStyled.PaymentErrorStyled, null, generalError)), (order === null || order === void 0 ? void 0 : (_order$offerId = order.offerId) === null || _order$offerId === void 0 ? void 0 : _order$offerId.charAt(0)) === 'S' && /*#__PURE__*/_react.default.createElement(_LegalNote.default, {
    order: order,
    period: period
  }));
};
exports.PurePayment = Payment;
Payment.propTypes = {
  onPaymentComplete: _propTypes.default.func.isRequired
};
var _default = Payment;
exports.default = _default;